/** The frame of every sign-in page: a navy brand panel beside a calm form column (no session yet, so no top bar or rail). */
import type { ReactNode } from "react";
import "../shell/shell.css";
import "./auth.css";

export function AuthLayout({ children }: { readonly children: ReactNode }) {
  return (
    <div className="gx-auth">
      <aside className="gx-auth-brand">
        <div className="gx-brand">
          <div className="gx-mark" aria-hidden="true">G</div>
          <div><div className="gx-wordmark">Governexus</div><div className="gx-product">Bank Simulator</div></div>
        </div>
        <div className="gx-auth-pitch">
          <h2 className="gx-auth-display">Take the chair.</h2>
          <p className="gx-auth-lede">Run a bank through a changing market. Set the strategy, weigh the risks, and see what your decisions do for shareholders.</p>
        </div>
        <div className="gx-auth-brand-foot">Governexus</div>
      </aside>
      <main className="gx-auth-main"><div className="gx-auth-col">{children}</div></main>
    </div>
  );
}
